$(document).ready(() => {
  clickTestiomonials();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    clickTestiomonials();
  });
}

function clickTestiomonials() {
  $(".new-testimonials-arrows > button").off("click.newTestimonials").on("click.newTestimonials", function (e) {
    var el = e.currentTarget;
    var container = $(el).parent()[0];
    var sectionId = $(container).attr("data-section-id");
    var direction = $(el).hasClass("new-testimonials-arrow-left") ? -1 : 1;
    var testimonialsContainer = $(".new-testimonials-content-" + sectionId)[0];

    if (!testimonialsContainer) return;

    var testimonials = $(testimonialsContainer).find(".new-testimonial");
    if (!testimonials.length) return;

    var testimonialsContainerOffset = $(testimonialsContainer).scrollLeft();
    var testimonialsWidth = getWidth_wm(testimonials[0]);
    var fractionOffset = (testimonialsContainerOffset / testimonialsWidth) % 1;

    if (direction > 0) {
      fractionOffset = (1 - fractionOffset);
      if (Math.round(fractionOffset) == 0) {
        fractionOffset = 1;
      }
    } else {
      if (fractionOffset == 0) {
        fractionOffset = 1;
      }
    }

    var newScrollLeft = testimonialsContainerOffset + direction * testimonialsWidth * fractionOffset;

    $(testimonialsContainer).animate(
      { scrollLeft: newScrollLeft },
      200,
      function () {
        announceActiveTestimonial(sectionId, testimonialsContainer, testimonialsWidth);
      }
    );
  });
}

function announceActiveTestimonial(sectionId, testimonialsContainer, testimonialsWidth) {
  var testimonials = $(testimonialsContainer).find(".new-testimonial");
  if (!testimonials.length) return;

  var currentScroll = $(testimonialsContainer).scrollLeft();
  var activeIndex = Math.round(currentScroll / testimonialsWidth);

  if (activeIndex < 0) activeIndex = 0;
  if (activeIndex >= testimonials.length) activeIndex = testimonials.length - 1;

  var activeTestimonial = testimonials.eq(activeIndex);
  var title = $.trim(activeTestimonial.find(".new-testimonial-header").text());
  var customer = $.trim(activeTestimonial.find(".new-testimonial-customer-name").text());

  var liveRegion = $("#new-testimonials-live-region-" + sectionId);
  if (!liveRegion.length) return;

  liveRegion.text("");

  setTimeout(function () {
    if (title || customer) {
      liveRegion.text("Testimonial changed. " + title + " " + customer);
    } else {
      liveRegion.text("Testimonial changed.");
    }
  }, 50);
}

function getWidth_wm(theDiv) {
  theDiv = $(theDiv);
  var totalWidth = theDiv.width();
  totalWidth += parseInt(theDiv.css("padding-left"), 10) + parseInt(theDiv.css("padding-right"), 10);
  totalWidth += parseInt(theDiv.css("borderLeftWidth"), 10) + parseInt(theDiv.css("borderRightWidth"), 10);
  return totalWidth;
}